import styled from "styled-components";
import { Box, Link, AspectRatio, Img, SimpleGrid } from "@xcorejs/ui";
import { InstagramPost } from "@robe/core";

const InstagramCardStyle = styled(Link)`
  img {
    transition: filter 600ms;

    & + div {
      transition: opacity 600ms;
    }
  }
  &:hover {
    img {
      filter: none;
      & + div {
        opacity: 0;
      }
    }
  }
`;

const Image = styled(Img)`
  width: 100%;
  height: 100%;
`;

interface InstagramPostsGridProps {
  posts: InstagramPost[];
}

export const InstagramPostsGrid = ({ posts }: InstagramPostsGridProps) => (
  <SimpleGrid columns={{ _: 2, sm: 6 }} gap="0">
    {posts.map((post, i) => {
      return (
        <InstagramCardStyle key={i} type="simple" target="_blank" href={post.permalink}>
          <AspectRatio ratio={1} position="relative">
            <Image src={post.imageUrl} alt="Instagram Photo" filter="saturate(0%)" loading="lazy" />
            <Box position="absolute" top={0} bottom={0} left={0} right={0} backgroundColor="rgba(211, 0, 49, .7)" />
          </AspectRatio>
        </InstagramCardStyle>
      );
    })}
  </SimpleGrid>
);
